import { render, staticRenderFns } from "./FormRulesets.vue?vue&type=template&id=45fe4d3a"
import script from "./FormRulesets.vue?vue&type=script&lang=js"
export * from "./FormRulesets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports